module.exports = __webpack_public_path__ + "static/img/s18.ff865015.png";